import { colors } from '@mehilainen/design-system-tokens';
// NOTE: Do not import these from lib root! Will cause circular deps
export const focusVisible = {
    outlineOffset: '2px',
    outlineColor: colors.Info600,
    outlineWidth: '2px',
    outlineStyle: 'solid',
    boxShadow: 'unset !important',
};
